import IntenToOfferIcon from 'components/icons/DriveTableIcon/IntentToOffer'
import OfferAcceptedIcon from 'components/icons/DriveTableIcon/OfferAccepted'
import OfferIssuedIcon from 'components/icons/DriveTableIcon/OfferIssued'
import React from 'react'
import { IconContainer, IconText } from '../../style'
import { AllowButton } from './Style'
import ResumeDownload from '../../../../components/icons/DriveTableIcon/ResumeDownload'

export default function OfferTableStatusIcon({
  onChange,
  status,
  selectedCandidateId,
  candidateStatus,
  handleDownload
}) {
  const isDisabled = selectedCandidateId.length === 0

  return (
    <IconContainer>
      <IconText>Sect status</IconText>
      {(status === 'ACTIVE' ||
        status === 'ACCEPTED' ||
        status === 'REJECTED') && (
        <AllowButton
          onClick={() =>
            isDisabled || candidateStatus.includes('RELEASED')
              ? ''
              : onChange('RELEASED')
          }
          disabled={isDisabled || candidateStatus.includes('RELEASED')}
        >
          <IntenToOfferIcon />
        </AllowButton>
      )}
      {(status === 'RELEASED' ||
        status === 'ACTIVE' ||
        status === 'REJECTED') && (
        <AllowButton
          onClick={() =>
            isDisabled || candidateStatus.includes('ACCEPTED')
              ? ''
              : onChange('ACCEPTED')
          }
          disabled={isDisabled || candidateStatus.includes('ACCEPTED')}
        >
          <OfferAcceptedIcon />
        </AllowButton>
      )}
      {(status === 'RELEASED' ||
        status === 'ACTIVE' ||
        status === 'REJECTED' ||
        status === 'ACCEPTED') && (
        <AllowButton
          onClick={() =>
            isDisabled || candidateStatus.includes('REJECTED')
              ? ''
              : onChange('REJECTED')
          }
          disabled={isDisabled || candidateStatus.includes('REJECTED')}
        >
          <OfferIssuedIcon />
        </AllowButton>
      )}    
       {(status === 'RELEASED' ||
        status === 'ACTIVE' ||
        status === 'ACCEPTED') && (
        <AllowButton
        onClick={e => {
          e.stopPropagation()
          if (!isDisabled) {
            handleDownload()
          }
        }}
          disabled={isDisabled}
        >
        <ResumeDownload />
        </AllowButton>
      )}    

    </IconContainer>
  )
}
